import React from 'react';

interface DropdownProps {
  label: string | React.ReactNode;
  selectedValue: string;
  onChange: (value: string) => void;
  options: Array<{ value: string; label: string; key?: string }>;
  placeholder?: string;
  hasError?: boolean;
  disabled?: boolean;
}

const Dropdown: React.FC<DropdownProps> = ({
  label,
  selectedValue,
  onChange,
  options,
  placeholder,
  hasError = false,
  disabled = false
}) => {
  return (
    <div className={`dropdown-container ${disabled ? 'opacity-50' : ''}`}>
      <label className="dropdown-label">{label}</label>
      <select
        value={selectedValue}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={`dropdown-select ${hasError ? '!border-red-500 !border-2 !focus:border-red-500 !focus:ring-red-200' : ''} ${disabled ? 'cursor-not-allowed' : ''}`}
      >
        {placeholder && <option key="placeholder" value="">{placeholder}</option>}
        {options.map((option, index) => {
          const optionKey = option.key || `${option.value}_${index}`;
          return (
            <option key={optionKey} value={option.value}>
              {option.label}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default Dropdown;